module.exports = __webpack_public_path__ + "assets/img/iProFun.23b8306a.jpg";